import styled from "@emotion/styled";
import { HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH, MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import colors from "styles/colors";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR, WHITE_COLOR_NAME } from "styles/color-consts";
export const StyledCareersHeroComponent = styled.section`
  &.section-hero {
    color: ${colors[WHITE_COLOR_NAME]};
    background: ${colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
    padding: 50px 0;
    display: flex;
    flex-direction: column;
    gap: 50px;

    .side-by-side-title-and-image {
      .paragraph-wrapper .paragraph-body {
        display: none;
      }

      .core-title-container .core-title {
        font-size: 100px;
        font-weight: 600;
        line-height: 100%;
        letter-spacing: -3px;
        max-width: 500px;
      }

      .image-wrapper {
        padding: 0 !important;
      }
    }

    .side-by-side-text-and-proof {
      .paragraph-wrapper .paragraph-body {
        font-size: 16px;
      }
    }

    /* MEDIUM TITLE */
    @media (max-width: ${HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH}) {
      .side-by-side-title-and-image {
        .core-title-container .core-title {
          font-size: 72px;
          max-width: none;
        }
      }
    }

    /* MOBILE DESIGN */
    @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
      gap: 0;

      .side-by-side-title-and-image {
        padding: 0;

        .full-paragraph {
          align-items: center;
          text-align: center !important;
        }

        .paragraph-wrapper .paragraph-body {
          display: block;
        }
      }

      .side-by-side-text-and-proof {
        display: none;
      }
    }

    /* MOBILE TITLE */
    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
      .side-by-side-title-and-image {
        .core-title-container .core-title {
          font-size: 40px;
          font-weight: 600;
          line-height: 100%;
          letter-spacing: -1.2px;
          max-width: none;
        }
      }
    }
  }
`;
